/* eslint-disable max-lines */
import { createTheme } from '@material-ui/core/styles';
import { alpha, darken, lighten } from '@material-ui/core/styles/colorManipulator';
import createPalette from '@material-ui/core/styles/createPalette';
import muiShadows from '@material-ui/core/styles/shadows';
export const shadows = [...muiShadows];
export const liquidityThemeFallbackFonts = [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    '"Helvetica"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
];
/*
NOTE: Please try not to add new color's, verify below if you can use existing colors
explore ColorManipulator for alpha, darken, lighten variants of a color
*/
export const palette = createPalette({
    type: 'light',
    text: {
        primary: 'rgba(33, 31, 31, 0.87)',
        secondary: 'rgba(33, 31, 31, 0.64)',
        disabled: 'rgba(33, 31, 31, 0.38)',
        inverse: '#FFFFFF',
        hint: 'rgba(33,31,31, 0.54)',
    },
    primary: {
        main: '#06a76c',
        dark: '#058556',
        light: '#07c57f',
        contrastText: '#FFFFFF',
        lightShade190p: lighten('#06a76c', 0.9),
        darkShade160p: darken('#06a76c', 0.6),
        contrastTextLarge: '#ffffff',
        contrastTextSmall: '#052E22',
    },
    secondary: {
        main: '#2C324F',
        dark: '#040A27',
        light: '#565B7B',
        contrastText: '#FFFFFF',
        lightShade190p: lighten('#2C324F', 0.9),
        darkShade160p: darken('#2C324F', 0.6),
    },
    error: {
        main: '#E14F42',
        dark: '#CF2F21',
        light: '#E8786E',
        contrastText: '#260D0B',
        lightShade190p: lighten('#E14F42', 0.9),
        darkShade160p: darken('#E14F42', 0.6),
    },
    warning: {
        main: '#F2C113',
        dark: '#BB9100',
        light: '#FFF354',
        contrastText: '#3D2F05',
        lightShade190p: lighten('#F2C113', 0.9),
        darkShade160p: darken('#F2C113', 0.6),
    },
    info: {
        main: '#369DD9',
        dark: '#006FA7',
        light: '#74CEFF',
        contrastText: '#0A2B3D',
        contrastTextLarge: '#ffffff',
        contrastTextSmall: '#0A2B3D',
        lightShade190p: lighten('#369DD9', 0.9),
        darkShade160p: darken('#369DD9', 0.6),
    },
    success: {
        main: '#06A76C',
        dark: '#058556',
        light: '#07C57F',
        contrastText: '#052E22',
        contrastTextLarge: '#ffffff',
        contrastTextSmall: '#052E22',
        lightShade190p: lighten('#06A76C', 0.9),
        darkShade160p: darken('#06a76c', 0.6),
    },
    action: {
        active: 'rgba(33,31,31, 0.54)',
        hover: 'rgba(33,31,31, 0.04)',
        selected: 'rgba(33,31,31, 0.0.8)',
        disabled: 'rgba(33,31,31, 0.26)',
        disabledBackground: 'rgba(33,31,31, 0.12)',
        focus: 'rgba(33,31,31, 0.12)',
        disabledOpacity: 0.38,
    },
    background: {
        default: 'rgba(249, 249, 249, 1)',
        canvas: '',
        paper: 'rgba(255, 255, 255, 1)',
        hint: '#393939',
        backdropOverlay: 'rgba(57, 57, 57, 0.25)',
    },
    divider: 'rgba(57, 57, 57, 0.12)',
    common: {
        black: 'rgba(33, 31, 31, 1)',
        white: '#FFFFFF',
    },
    grey: {
        /*
        TODO: replace grey with these when rebrand work is stable
        if you need new variant of grey use from below list
        please don't use any arbitary value
    
        50: '#E7E7E7',
        100: '#C4C4C4',
        200: '#9C9C9C',
        300: '#747474',
        400: '#575757',
        500: '#393939',
        600: '#333333',
        700: '#2C2C2C',
        800: '#242424',
        900: '#171717',
        */
        50: '#fafafa',
        100: '#F5F5F5',
        200: '#eeeeee',
        300: '#E0E0E0',
        400: '#575757',
        500: '#9e9e9e',
        700: '#616161',
        800: '#242424',
        900: '#171717',
    },
    deepGrey: {
        /*
        TODO: replace deepGrey with these when rebrand work is stable
        if you need new variant of deepGrey use from below list
        please don't use any arbitary value
    
        50: '#E7E7E7',
        100: '#C4C4C4',
        200: '#9C9C9C',
        300: '#747474',
        400: '#575757',
        500: '#393939',
        600: '#333333',
        700: '#2C2C2C',
        800: '#242424',
        900: '#171717',
    
        */
        50: '#E7E7E7',
        100: 'rgba(155, 155, 155, 0.45)',
        200: 'rgba(57, 57, 57, 0.42)',
        300: '#979797',
        400: '#575757',
        500: '#393939',
        600: '#333333',
        700: '#2C2C2C',
        800: '#242424',
        900: '#171717',
    },
    /*
    TODO: remove tooltip color and use deepGrey
    */
    tooltip: {
        dark: '#393939',
        light: '#747474',
    },
    green: {
        50: '#E1F4ED',
        100: '#B4E5D3',
        200: '#83D3B6',
        300: '#51C198',
        400: '#2BB482',
        500: '#06A76C',
        600: '#059F64',
        700: '#049659',
        800: '#038C4F',
        900: '#027C3D',
        A100: '#A9FFCD',
        A200: '#76FFAF',
        A400: '#43FF91',
        A700: '#2AFF82',
    },
    blue: {
        50: '#E3EDF2',
        100: '#B8D1E0',
        200: '#89B2CB',
        300: '#5A93B6',
        400: '#367CA6',
        500: '#136596',
        600: '#115D8E',
        700: '#0E5383',
        800: '#0B4979',
        900: '#063768',
        A100: '#98C6FF',
        A200: '#65AAFF',
        A400: '#328EFF',
        A700: '#1980FF',
    },
    red: {
        50: '#FBEAE8',
        100: '#F6CAC6',
        200: '#F0A7A1',
        300: '#EA847B',
        400: '#E6695E',
        500: '#E14F42',
        600: '#DD483C',
        700: '#D93F33',
        800: '#D5362B',
        900: '#CD261D',
        A100: '#FFEEED',
        A200: '#FFD2D0',
        A400: '#FFA19D',
        A700: '#FF8984',
    },
    pink: {
        50: '#FBECF6',
        100: '#F4CEE8',
        200: '#EDAED8',
        300: '#E68EC8',
        400: '#E075BD',
        500: '#DB5DB1',
        600: '#D755AA',
        700: '#D24BA1',
        800: '#CD4198',
        900: '#C43088',
        A100: '#FFE6F4',
        A200: '#FFD5ED',
        A400: '#FFA2D8',
        A700: '#C51162',
    },
    purple: {
        50: '#F6EFFB',
        100: '#E9D7F5',
        200: '#DBBCEE',
        300: '#CDA1E7',
        400: '#C28CE2',
        500: '#B778DD',
        600: '#B070D9',
        700: '#A765D4',
        800: '#9F5BCF',
        900: '#9048C7',
        A100: '#FAF4FF',
        A200: '#F6EBFF',
        A400: '#E0B8FF',
        A700: '#D49FFF',
    },
    deepPurple: {
        50: '#EDE9F5',
        100: '#D2C8E6',
        200: '#B39DDB',
        300: '#977EC4',
        400: '#8062B7',
        500: '#6A46AA',
        600: '#5E35B1',
        700: '#623FA3',
        800: '#4D2F90',
        900: '#3C207F',
        A100: '#CEBDFF',
        A200: '#A98AFF',
        A400: '#8357FF',
        A700: '#713DFF',
    },
    lightBlue: {
        50: '#E7F3FA',
        100: '#C3E2F4',
        200: '#9BCEEC',
        300: '#72BAE4',
        400: '#54ACDF',
        500: '#369DD9',
        600: '#3095D5',
        700: '#298BCF',
        800: '#2281CA',
        900: '#166FC0',
        A100: '#F2F9FF',
        A200: '#BFDFFF',
        A400: '#8CC5FF',
        A700: '#73B8FF',
    },
    cyan: {
        50: '#B2EBF2',
        100: '#E0F7FA',
        200: '#80DEEA',
        300: '#4DD0E1',
        400: '#26C6DA',
        500: '#00BCD4',
        600: '#00ACC1',
        700: '#0097A7',
        800: '#00838F',
        900: '#006064',
        A100: '#84FFFF',
        A200: '#18FFFF',
        A400: '#00E5FF',
        A700: '#00B8D4',
    },
    teal: {
        50: '#E4F4F6',
        100: '#BBE4E7',
        200: '#8ED2D8',
        300: '#60BFC8',
        400: '#3EB2BC',
        500: '#1CA4B0',
        600: '#199CA9',
        700: '#1492A0',
        800: '#118997',
        900: '#097887',
        A100: '#B6F5FF',
        A200: '#83EEFF',
        A400: '#50E7FF',
        A700: '#36E4FF',
    },
    lightGreen: {
        50: '#EEF8F5',
        100: '#D5EFE5',
        200: '#BAE4D4',
        300: '#9ED9C3',
        400: '#89D0B6',
        500: '#74C8A9',
        600: '#6CC2A2',
        700: '#61BB98',
        800: '#57B48F',
        900: '#44A77E',
        A100: '#DDFFF1',
        A200: '#CAFFE9',
        A400: '#97FFD3',
        A700: '#7EFFC8',
    },
    lime: {
        50: '#F3F9E9',
        100: '#E1F1C7',
        200: '#CDE8A2',
        300: '#B9DE7D',
        400: '#AAD761',
        500: '#9BD045',
        600: '#93CB3E',
        700: '#89C436',
        800: '#7FBE2E',
        900: '#6DB31F',
        A100: '#F5FFEB',
        A200: '#DCFFB8',
        A400: '#C3FF85',
        A700: '#B6FF6C',
    },
    yellow: {
        50: '#FDF8E3',
        100: '#FBECB8',
        200: '#F9E089',
        300: '#F6D45A',
        400: '#F4CA36',
        500: '#F2C113',
        600: '#F0BB11',
        700: '#EEB30E',
        800: '#ECAB0B',
        900: '#E89E06',
        A100: '#FFFBF5',
        A200: '#FFF3DD',
        A400: '#FFE0AA',
        A700: '#FFD791',
    },
    amber: {
        50: '#FDF3E1',
        100: '#FAE0B5',
        200: '#F7CB84',
        300: '#F3B653',
        400: '#F1A72E',
        500: '#EE9709',
        600: '#EC8F08',
        700: '#E98406',
        800: '#E77A05',
        900: '#E26902',
        A100: '#FEEADC',
        A200: '#FFE7D6',
        A400: '#FFC8A3',
        A700: '#FFB98A',
    },
    orange: {
        50: '#FDEDE0',
        100: '#F9D3B3',
        200: '#F5B680',
        300: '#F1994D',
        400: '#EE8326',
        500: '#EB6D00',
        600: '#E96500',
        700: '#E55A00',
        800: '#E25000',
        900: '#DD3E00',
        A100: '#FFEBE6',
        A200: '#FFDBD1',
        A400: '#FFB39E',
        A700: '#FF9F85',
    },
    deepOrange: {
        50: '#F6E9E0',
        100: '#EAC9B3',
        200: '#DCA580',
        300: '#CD804D',
        400: '#C36526',
        500: '#B84A00',
        600: '#B14300',
        700: '#A83A00',
        800: '#A03200',
        900: '#912200',
        A100: '#FFC7BD',
        A200: '#FF9C8A',
        A400: '#FF7157',
        A700: '#FF5C3D',
    },
    blueGrey: {
        50: '#ECEFF1',
        100: '#CFD8DC',
        200: '#B0BEC5',
        300: '#90A4AE',
        400: '#78909C',
        500: '#607D8B',
        600: '#546E7A',
        700: '#455A64',
        800: '#37474F',
        900: '#263238',
    },
    deepBlue: {
        50: '#E6E6EA',
        100: '#C0C2CA',
        200: '#9699A7',
        300: '#6B7084',
        400: '#4C5169',
        500: '#2C324F',
        600: '#272D48',
        700: '#21263F',
        800: '#1B1F36',
        900: '#101326',
    },
    /*
    TODO: remove liquidity
    */
    liquidity: {
        textStandard: 'rgba(33, 31, 31, 0.87)',
        supportingGrey: 'rgba(57, 57, 57, 0.25)',
        miscCanvas: '#f5f3f2',
        grey10: '#F5F5F5',
        grey25: '#fafafa',
        brightBlue: '#0095a9',
    },
});
/**
 * Liquidity Theme
 * This is the base theme for Liquidity. It defines the color scheme and typography that material-ui will use
 */
export const LiquidityTheme = createTheme({
    name: 'liquidity',
    typography: {
        h1: {
            fontFamily: ['Libre Baskerville', 'serif', ...liquidityThemeFallbackFonts].join(','),
            fontWeight: 400,
            fontSize: '6rem',
        },
    },
    overrides: {
        PaginationItem: {
            root: {
                fontWeight: 700,
            },
            textPrimary: {
                '&$selected:disabled': {
                    backgroundColor: alpha(palette.primary.main, palette.action.disabledOpacity),
                },
            },
            textSecondary: {
                '&$selected:disabled': {
                    color: palette.common.white,
                    backgroundColor: alpha(palette.secondary.main, palette.action.disabledOpacity),
                },
            },
            outlinedPrimary: {
                '&$selected:disabled': {
                    backgroundColor: alpha(palette.primary.main, 0.12),
                    borderColor: alpha(palette.primary.main, palette.action.disabledOpacity),
                    color: alpha(palette.primary.main, palette.action.disabledOpacity),
                },
            },
            outlinedSecondary: {
                '&$selected:disabled': {
                    backgroundColor: alpha(palette.secondary.main, 0.12),
                    borderColor: alpha(palette.secondary.main, palette.action.disabledOpacity),
                    color: alpha(palette.secondary.main, palette.action.disabledOpacity),
                },
            },
        },
        MuiLink: {
            root: {
                fontWeight: 700,
            },
        },
        MuiCssBaseline: {
            /*
              it removes auto clear icon from search box
             */
            '@global': {
                html: {
                    fontFamily: ['Roboto', ...liquidityThemeFallbackFonts].join(', '),
                },
                'input[type="search"]::-webkit-search-cancel-button': {
                    '-webkit-appearance': 'none',
                },
            },
        },
        MuiButton: {
            root: {
                textTransform: 'capitalize',
                borderRadius: '2.8125rem',
                fontWeight: 700,
                paddingY: 2,
                paddingX: 3,
                border: '1px solid transparent',
                fontSize: '1.1875rem',
            },
            text: {
                // border set zero to handle ButtonGroup implementation where button borders getting visible for text variants
                border: 0,
                padding: '6px 16px',
            },
            textPrimary: {
                color: palette.primary.dark,
            },
            outlined: {
                borderWidth: '2px',
                '&$disabled, &:hover': {
                    borderWidth: '2px',
                },
            },
            outlinedSecondary: {
                borderWidth: '1.5px',
                borderColor: palette.secondary.main,
                '&:hover': {
                    borderWidth: '1.5px',
                },
            },
            sizeLarge: {
                fontSize: '1.375rem',
                fontWeight: 700,
            },
            sizeSmall: {
                fontSize: '1rem',
            },
        },
        DestructiveButton: {
            root: {
                '&:disabled': {
                    color: alpha(palette.text.inverse, palette.action.disabledOpacity),
                    backgroundColor: alpha(palette.error.main, palette.action.disabledOpacity),
                },
            },
        },
        CTAButton: {
            root: {
                backgroundColor: palette.primary.main,
                // border: '3px solid transparent',
                border: 0,
                color: palette.text.inverse,
                position: 'relative',
                transformStyle: 'preserve-3d',
                transition: 'all 150ms cubic-bezier(.175, .885, .32, 1.275)',
                '&::before': {
                    content: '" "',
                    background: palette.secondary.main,
                    borderRadius: 'inherit',
                    height: '100%',
                    width: '100%',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    position: 'absolute',
                    transform: 'translate3d(-.2em, .3em, -1em)',
                    transition: 'all 150ms cubic-bezier(.175, .885, .32, 1.275)',
                },
                '&:hover': {
                    backgroundColor: palette.primary.dark,
                    boxShadow: shadows[0],
                    '&::before': {
                        boxShadow: shadows[2],
                    },
                },
                '&:active': {
                    transform: 'translate(-.2em, .3em)',
                    '&::before': {
                        transform: 'translate3d(0, 0, -1em)',
                    },
                },
                '&:disabled': {
                    backgroundColor: lighten(palette.primary.main, 0.3),
                    color: palette.text.inverse,
                    '&::before': {
                        backgroundColor: lighten(palette.secondary.main, 0.3),
                    },
                },
            },
            containedPrimary: {
                backgroundColor: palette.secondary.main,
                '&:hover': {
                    backgroundColor: palette.secondary.dark,
                },
                '&$disabled': {
                    backgroundColor: lighten(palette.secondary.main, 0.3),
                    '&::before': {
                        backgroundColor: darken(palette.common.white, 0.3),
                    },
                },
                '&::before': {
                    background: palette.common.white,
                },
            },
            containedSecondary: {
                backgroundColor: palette.primary.main,
                '&$disabled': {
                    backgroundColor: lighten(palette.primary.main, 0.3),
                    '&::before': {
                        backgroundColor: darken(palette.common.white, 0.3),
                    },
                },
                '&::before': {
                    background: palette.common.white,
                },
            },
        },
        MuiTable: {
            root: {
                borderCollapse: 'collapse',
                borderSpacing: 0,
                backgroundColor: palette.common.white,
            },
        },
        MuiTableRow: {
            root: {
                borderBottom: `1px solid ${palette.divider}`,
                '&$hover:hover': {
                    backgroundColor: palette.action.hover,
                },
                '&$selected': {
                    backgroundColor: alpha(palette.primary.main, 0.04),
                },
                '&$selected:hover': {
                    backgroundColor: alpha(palette.success.main, 0.04),
                },
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: 'none',
                paddingX: 8,
                paddingY: 16,
                '&:first-child': {
                    paddingLeft: 16,
                },
                '&:last-child': {
                    paddingRight: 16,
                },
            },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: '0.8125rem',
                fontWeight: 500,
                padding: '4px 8px',
                borderRadius: 5,
            },
        },
        MuiCheckbox: {
            root: {
                color: palette.deepGrey[200],
                '&$disabled': {
                    color: palette.action.disabled,
                },
                '&$checked': {
                    color: palette.grey[700],
                    '&$disabled': {
                        color: palette.action.disabled,
                    },
                },
            },
            colorPrimary: {
                '&$disabled': {
                    color: palette.action.disabled,
                },
                '&$checked': {
                    color: palette.primary.main,
                    '&$disabled': {
                        color: alpha(palette.primary.main, palette.action.disabledOpacity),
                    },
                },
            },
            colorSecondary: {
                '&$disabled': {
                    color: palette.action.disabled,
                },
                '&$checked': {
                    color: palette.secondary.main,
                    '&$disabled': {
                        color: alpha(palette.secondary.main, palette.action.disabledOpacity),
                    },
                },
            },
        },
        MuiRating: {
            root: {
                color: palette.warning.main,
            },
        },
        MuiChip: {
            root: {
                fontWeight: 600,
                fontSize: '0.875rem',
            },
            outlined: {
                backgroundColor: alpha(palette.text.disabled, 0.05),
            },
            outlinedPrimary: {
                backgroundColor: alpha(palette.primary.main, 0.05),
            },
            outlinedSecondary: {
                backgroundColor: alpha(palette.secondary.main, 0.05),
            },
        },
        MuiSwitch: {
            switchBase: {
                color: palette.grey[50],
                '&$checked': {
                    '&:hover': {
                        backgroundColor: palette.action.hover,
                        '@media (hover: none)': {
                            backgroundColor: 'transparent',
                        },
                    },
                },
                '&$disabled': {
                    color: palette.grey[100],
                },
                '&$disabled + $track': {
                    backgroundColor: palette.action.disabledBackground,
                    opacity: 1,
                },
            },
            track: {
                backgroundColor: palette.background.hint,
            },
            colorPrimary: {
                color: palette.grey[50],
                '&$checked': {
                    color: palette.primary.main,
                    '&:hover': {
                        backgroundColor: alpha(palette.primary.main, palette.action.hoverOpacity),
                        '@media (hover: none)': {
                            backgroundColor: 'transparent',
                        },
                    },
                    '&$disabled': {
                        color: palette.green[100],
                    },
                    '&$disabled + $track': {
                        backgroundColor: alpha(palette.primary.main, palette.action.disabledOpacity),
                    },
                },
                '&$disabled': {
                    color: palette.grey[100],
                },
                '&$disabled + $track': {
                    backgroundColor: palette.action.disabledBackground,
                },
                '&$checked + $track': {
                    backgroundColor: palette.primary.main,
                },
            },
            colorSecondary: {
                color: palette.grey[50],
                '&$checked': {
                    color: palette.secondary.main,
                    '&:hover': {
                        backgroundColor: alpha(palette.secondary.main, palette.action.hoverOpacity),
                        '@media (hover: none)': {
                            backgroundColor: 'transparent',
                        },
                    },
                    '&$disabled': {
                        color: palette.deepBlue[100],
                    },
                    '&$disabled + $track': {
                        backgroundColor: alpha(palette.secondary.main, palette.action.disabledOpacity),
                    },
                },
                '&$disabled': {
                    color: palette.grey[100],
                },
                '&$disabled + $track': {
                    backgroundColor: palette.action.disabledBackground,
                },
                '&$checked + $track': {
                    backgroundColor: palette.secondary.main,
                },
            },
        },
        TypeDetailsHeader: {
            root: {
                fontFamily: 'Libre Baskerville, serif',
            },
        },
        TypePageTitle: {
            root: {
                fontFamily: 'Libre Baskerville, serif',
            },
        },
        TypeWidgetHeader: {
            root: {
                fontFamily: 'Libre Baskerville, serif',
                textTransform: 'capitalize',
            },
        },
        MuiTextField: {
            root: {
                '& $label': {
                    '&.Mui-focused': {
                        color: palette.success.dark,
                    },
                    '&.Mui-error': {
                        color: palette.error.dark,
                    },
                },
                '& p': {
                    '&.Mui-focused': {
                        color: palette.success.dark,
                    },
                    '&.Mui-error': {
                        color: palette.error.dark,
                    },
                },
            },
        },
        MuiRadio: {
            root: {
                color: palette.deepGrey[200],
                '&$disabled': {
                    color: palette.action.disabled,
                },
                '&$checked': {
                    color: palette.grey[700],
                    '&$disabled': {
                        color: palette.action.disabled,
                    },
                },
            },
            colorPrimary: {
                '&$disabled': {
                    color: palette.action.disabled,
                },
                '&$checked': {
                    color: palette.primary.main,
                    '&$disabled': {
                        color: alpha(palette.primary.main, palette.action.disabledOpacity),
                    },
                },
            },
            colorSecondary: {
                '&$disabled': {
                    color: palette.action.disabled,
                },
                '&$checked': {
                    color: palette.secondary.main,
                    '&$disabled': {
                        color: alpha(palette.secondary.main, palette.action.disabledOpacity),
                    },
                },
            },
        },
        MuiListItem: {
            root: {
                '&:hover': {
                    backgroundColor: alpha(palette.info.main, 0.04),
                },
                '&$focusVisible': {
                    backgroundColor: alpha(palette.info.main, 0.04),
                },
                '&$selected': {
                    backgroundColor: alpha(palette.info.main, 0.12),
                    borderLeft: `4px solid ${palette.info.main}`,
                },
                '&$selected:hover': {
                    backgroundColor: alpha(palette.info.main, 0.04),
                },
                '&$button:hover': {
                    backgroundColor: alpha(palette.info.main, 0.04),
                },
                '& .MuiTouchRipple-root': {
                    color: alpha(palette.info.main, 0.3),
                },
            },
        },
        MuiSlider: {
            colorPrimary: {
                '& $valueLabel': {
                    '& *': {
                        backgroundColor: palette.primary.main,
                        color: palette.text.primary,
                    },
                },
            },
            valueLabel: {
                '& *': {
                    fontSize: '14px',
                },
            },
        },
        MuiAppBar: {
            colorDefault: {
                backgroundColor: palette.background.paper,
            },
        },
        AlertBanner: {
            filledSuccess: {
                color: palette.text.primary,
            },
            filledInfo: {
                color: palette.text.primary,
            },
            filledWarning: {
                color: palette.text.primary,
            },
            filledError: {
                color: palette.text.primary,
            },
            standardSuccess: {
                backgroundColor: palette.success.lightShade190p,
                borderColor: palette.success.darkShade160p,
                color: palette.success.darkShade160p,
            },
            standardInfo: {
                backgroundColor: palette.info.lightShade190p,
                borderColor: palette.info.darkShade160p,
                color: palette.info.darkShade160p,
            },
            standardWarning: {
                backgroundColor: palette.warning.lightShade190p,
                borderColor: palette.warning.darkShade160p,
                color: palette.warning.darkShade160p,
            },
            standardError: {
                backgroundColor: palette.error.lightShade190p,
                borderColor: palette.error.darkShade160p,
                color: palette.error.darkShade160p,
            },
        },
        MuiTab: {
            root: {
                '&$selected': {
                    backgroundColor: alpha(palette.secondary.main, 0.04),
                    fontWeight: 700,
                    '&$textColorPrimary': {
                        color: palette.text.primary,
                    },
                    '&$textColorSecondary': {
                        color: palette.text.primary,
                    },
                },
                textTransform: 'capitalize',
            },
            textColorPrimary: {
                color: palette.text.primary,
            },
            textColorSecondary: {
                color: palette.text.secondary,
            },
        },
        MuiTabs: {
            indicator: {
                left: 0,
            },
        },
        MuiButtonGroup: {
            root: {
                '&$contained': {
                    boxShadow: 'none',
                },
                '&$vertical': {
                    '&>:first-child': {
                        borderTopLeftRadius: '.9375rem',
                        borderTopRightRadius: '.9375rem',
                    },
                    '&>:last-child': {
                        borderBottomLeftRadius: '.9375rem',
                        borderBottomRightRadius: '.9375rem',
                    },
                },
            },
            groupedOutlined: {
                borderWidth: '1px',
            },
            groupedContained: {
                border: 'none',
            },
        },
        MuiFormHelperText: {
            root: {
                fontSize: '0.875rem',
            },
        },
        MuiFormLabel: {
            root: {
                '&$focused': {
                    color: palette.success.dark,
                },
            },
        },
        MuiPaper: {
            root: {
                borderRadius: 5,
            },
            rounded: {
                borderRadius: 15,
            },
        },
        MuiMenu: {
            paper: {
                borderRadius: '5px',
            },
        },
        TableSortLabel: {
            icon: {
                color: `${palette.secondary.main} !important`,
            },
        },
    },
    palette,
    props: {
        MuiButton: {
            disableElevation: true,
        },
        MuiCheckbox: {
            color: 'default',
        },
        MuiRadio: {
            color: 'default',
        },
        MuiAppBar: {
            color: 'default',
        },
    },
    spacing: 8,
    shape: {
        borderRadius: 5,
    },
    shadows,
});
//# sourceMappingURL=Liquidity.js.map